export default "/fonts/vendor/katex/dist/KaTeX_Main-BoldItalic.woff?428978dc7837d46de0916f266f5a43df";